<template>
  <div v-if="creditCard">
    <ul v-if="!props.onlyShowAddress" id="credit-card-info" class="mb">
      <li>{{ `${creditCard.cardType} ${tn("endingIn")} ${creditCard.lastDigits}` }}</li>
      <li>
        {{ tn("exp") }}
        {{ expirationDate() }}
      </li>
    </ul>
    <ul id="credit-card-address" class="mb-double">
      <li id="currentAccountHolder">{{ creditCard.accountHolder }}</li>
      <li id="currentAddress1">{{ creditCard.address.streetAddress1 }}</li>
      <li id="currentAddress2">{{ creditCard.address.streetAddress2 }}</li>
      <li id="currentCityStatePostalCode">
        {{ `${creditCard.address.city}, ${creditCard.address.stateOrProvince} ${creditCard.address.postalCode}` }}
      </li>
      <li id="currentCountry">{{ creditCard.address.country }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { t } from "@/i18n";
import { onBeforeMount, computed } from "vue";
import { logEvent } from "@/common/logger";
import { formatCCDateString } from "@/common/dateFormat";
import { useBuyFlowStore } from "@/stores/buyFlow";

const componentName = "BuySelectedCreditCardComponent";

const buyFlowStore = useBuyFlowStore();
logEvent("created", componentName);

const props = defineProps({
  selectedPaymentMethodId: {
    type: String,
    required: true,
  },
  onlyShowAddress: {
    type: Boolean,
    default: false,
  },
});

const creditCard = computed(() => {
  return buyFlowStore.creditCards.find(l => l.id === props.selectedPaymentMethodId) ?? null;
});

onBeforeMount(async () => {
  logEvent("mounting", componentName);
});

function tn(v: string, params?: Record<string, unknown>): string {
  return t(`${componentName}.${v}`, params);
}

function expirationDate() {
  return formatCCDateString(creditCard.value?.expirationDate || "");
}
</script>
<style scoped lang="css">
@import "@/styles/variables.css";
</style>
